import type { IFuseOptions } from 'fuse.js';

type SearchProps<T> = {
  listToSearch: T[];
  searchTerm: string;
  options?: IFuseOptions<T>;
};

export const search = async <T>({ listToSearch, searchTerm, options }: SearchProps<T>) => {
  // Dynamically load fuse.js
  const Fuse = (await import('fuse.js')).default;
  const fuse = new Fuse(listToSearch, options);
  return fuse.search(searchTerm);
};
